export default __webpack_public_path__ + "8d17477abd59c5f6bc7772baf04c8a83.png";